import { makeActive, checkAccessForList } from "modules/common/utils";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { globalStateSelector } from "store/selector";
import styled from "styled-components";
import { RowTitle } from "../styles/main";

const ReportingDropdown = styled.div`
  background: #fff;
  border-right: 1px solid #d9d9d9;
  z-index: 1;

  @media (max-width: 991px) {
    display: none;
  }

  .select {
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 30px;
    display: inline-flex;
    align-items: center;
    text-transform: uppercase;
    padding-left: 32px;
    color: #b1b1b1 !important;
    background: #f2f2f2;
    height: 40px;
    width: 260px;
    cursor: pointer;
    margin-bottom: 5px;
  }

  .icon {
    padding-right: 20px;
  }
  .option {
    padding-left: 32px;

    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 50px;
    transition: all 1s;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    color: #000000;
  }

  .active {
    display: flex;
    margin-left: 0px !important;
    border-left: 4px solid #28a6de;
    background: #f2f2f2;
  }
`;

export class ReportingDropdownMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: this.getlist(),
    };
  }

  getlist() {
    const { location = {}, currentUser } = this.props;
    let role = currentUser.role || "";
    const pathname = location.pathname || "";
    let list = [];

    if (role == 6) {
      list = [
        {
          name: "Agent",
          isShow: "none",
          color: "#ffff",
          arrow: "keyboard_double_arrow_down",
          childs: [
            {
              name: "Outbound",
              link: "/reporting/cdr/agent-outbound-cdr-report",
              active: false,
              accessName: "agent-outbound-cdr-report",
              index: 0,
            },
            {
              name: "Inbound",
              link: "/reporting/cdr/agent-inbound-cdr-report",
              active: false,
              accessName: "agent-inbound-cdr-report",
              index: 0,
            },
          ],
        },
      ];
    } else if (role == 5) {
      list = [
        {
          name: "Global",
          isShow: "none",
          color: "#ffff",
          arrow: "keyboard_double_arrow_down",
          childs: [
            {
              name: "Voice",
              link: "/reporting/cdr/voice-report",
              active: false,
              accessName: "voice-cdr-report",
              index: 0,
            },
            {
              name: "Outbound",
              link: "/reporting/cdr/outbound-cdr-report",
              active: false,
              accessName: "outbound-cdr-report",
              index: 0,
            },
            {
              name: "Inbound",
              link: "/reporting/cdr/inbound-cdr-report",
              active: false,
              accessName: "inbound-cdr-report",
              index: 0,
            },
            {
              name: "DNC",
              link: "/reporting/cdr/dnc-cdr-report",
              active: false,
              accessName: "dnc-cdr-report",
              index: 0,
            },
            {
              name: "Call Report",
              link: "/reporting/call-report",
              active: false,
              accessName: "call-report",
              index: 0,
            },
          ],
        },
        {
          name: "Message",
          isShow: "none",
          color: "#ffff",
          arrow: "keyboard_double_arrow_down",
          childs: [
            {
              name: "Message",
              link: "/reporting/message-cdr-report",
              active: false,
              accessName: "message-cdr-report",
              index: 1,
            },
          ],
        },
        {
          name: "Agent",
          isShow: "none",
          color: "#ffff",
          arrow: "keyboard_double_arrow_down",
          childs: [
            {
              name: "Outbound",
              link: "/reporting/cdr/agent-outbound-cdr-report",
              active: false,
              accessName: "agent-outbound-cdr-report",
              index: 2,
            },
            {
              name: "Inbound",
              link: "/reporting/cdr/agent-inbound-cdr-report",
              active: false,
              accessName: "agent-inbound-cdr-report",
              index: 2,
            },
            {
              name: "Outbound Drop",
              link: "/reporting/cdr/agent-outbound-drop-report",
              active: false,
              accessName: "agent-outbound-drop-report",
              index: 2,
            },
            {
              name: "Inbound Drop",
              link: "/reporting/cdr/agent-inbound-missed-report",
              active: false,
              accessName: "agent-inbound-missed-report",
              index: 2,
            },
            {
              name: "User Summary",
              link: "/reporting/user-summary",
              active: false,
              accessName: "user-summary-report",
              index: 2,
            },
            {
              name: "Break Summary",
              link: "/reporting/break-summary",
              active: false,
              accessName: "break-summary-report",
              index: 2,
            },
            {
              name: "Dispose Summary",
              link: "/reporting/despose-report",
              active: false,
              accessName: "dispose-summary-report",
              index: 2,
            },
            {
              name: "Call Back",
              link: "/reporting/callback-report",
              active: false,
              accessName: "callback-report",
              index: 2,
            },
            {
              name: "Team Summary",
              link: "/reporting/agent/team-summary",
              active: false,
              accessName: "team-summary-report",
              index: 2,
            },
            {
              name: "Campaign Summary",
              link: "/reporting/agent/campaign-summary",
              active: false,
              accessName: "campaign-summary-report",
              index: 2,
            },
            {
              name: "Auto Dispose Summary",
              link: "/reporting/agent/auto-dispose-summary",
              active: false,
              accessName: "auto-dispose-summary-report",
              index: 2,
            },
          ],
        },
        {
          name: "OBD",
          isShow: "none",
          color: "#ffff",
          arrow: "keyboard_double_arrow_down",
          childs: [
            {
              name: "Broadcast",
              link: "/reporting/cdr/broadcast-cdr-report",
              active: false,
              accessName: "broadcast-cdr-report",
              index: 3,
            },
          ],
        },
        {
          name: "Log",
          isShow: "none",
          color: "#ffff",
          arrow: "keyboard_double_arrow_down",
          childs: [
            {
              name: "Webhooks",
              link: "/reporting/webhooks-report",
              active: false,
              accessName: "webhook-report",
              index: 5,
            },
          ],
        },
      ];
    } else {
      list = [
        {
          name: "Global",
          isShow: "none",
          color: "#ffff",
          arrow: "keyboard_double_arrow_down",
          childs: [
            {
              name: "Voice",
              link: "/reporting/cdr/voice-report",
              active: false,
              accessName: "voice-cdr-report",
              index: 0,
            },
            {
              name: "Outbound",
              link: "/reporting/cdr/outbound-cdr-report",
              active: false,
              accessName: "outbound-cdr-report",
              index: 0,
            },
            {
              name: "Inbound",
              link: "/reporting/cdr/inbound-cdr-report",
              active: false,
              accessName: "inbound-cdr-report",
              index: 0,
            },
            {
              name: "DNC",
              link: "/reporting/cdr/dnc-cdr-report",
              active: false,
              accessName: "dnc-cdr-report",
              index: 0,
            },
            {
              name: "Call Report",
              link: "/reporting/call-report",
              active: false,
              accessName: "call-report",
              index: 0,
            },
          ],
        },
        {
          name: "Message",
          isShow: "none",
          color: "#ffff",
          arrow: "keyboard_double_arrow_down",
          childs: [
            {
              name: "Message",
              link: "/reporting/message-cdr-report",
              active: false,
              accessName: "message-cdr-report",
              index: 1,
            },
          ],
        },
        {
          name: "Agent",
          isShow: "none",
          color: "#ffff",
          arrow: "keyboard_double_arrow_down",
          childs: [
            {
              name: "Outbound",
              link: "/reporting/cdr/agent-outbound-cdr-report",
              active: false,
              accessName: "agent-outbound-cdr-report",
              index: 2,
            },
            {
              name: "Inbound",
              link: "/reporting/cdr/agent-inbound-cdr-report",
              active: false,
              accessName: "agent-inbound-cdr-report",
              index: 2,
            },
            {
              name: "Outbound Drop",
              link: "/reporting/cdr/agent-outbound-drop-report",
              active: false,
              accessName: "agent-outbound-drop-report",
              index: 2,
            },
            {
              name: "Inbound Drop",
              link: "/reporting/cdr/agent-inbound-missed-report",
              active: false,
              accessName: "agent-inbound-missed-report",
              index: 2,
            },
            {
              name: "User Summary",
              link: "/reporting/user-summary",
              active: false,
              accessName: "user-summary-report",
              index: 2,
            },
            {
              name: "Break Summary",
              link: "/reporting/break-summary",
              active: false,
              accessName: "break-summary-report",
              index: 2,
            },
            {
              name: "Dispose Summary",
              link: "/reporting/despose-report",
              active: false,
              accessName: "dispose-summary-report",
              index: 2,
            },
            {
              name: "Call Back",
              link: "/reporting/callback-report",
              active: false,
              accessName: "callback-report",
              index: 2,
            },
            {
              name: "Team Summary",
              link: "/reporting/agent/team-summary",
              active: false,
              accessName: "team-summary-report",
              index: 2,
            },
            {
              name: "Campaign Summary",
              link: "/reporting/agent/campaign-summary",
              active: false,
              accessName: "campaign-summary-report",
              index: 2,
            },
            {
              name: "Auto Dispose Summary",
              link: "/reporting/agent/auto-dispose-summary",
              active: false,
              accessName: "auto-dispose-summary-report",
              index: 2,
            },
            {
              name: "Provider Summary",
              link: "/reporting/provider-summary",
              active: false,
              accessName: "provider-summary-report",
              index: 2,
            },
            {
              name: "Carrier Status Summary",
              link: "/reporting/carrier-status-summary",
              active: false,
              accessName: "carrier-status-summary-report",
              index: 2,
            },
          ],
        },
        /*
				{
					name: 'Lead',
					isShow: 'none',
					color: '#ffff',
					arrow: 'keyboard_double_arrow_down',
					childs: [
						{
							name: 'Contact List Call Stats',
							link: '/reporting/lead/contact-list-call-statistics',
							active: false,
							accessName: 'contact-list-call-statistics-report',
							index: 2,
						},
						{
							name: 'Lead Status',
							link: '/reporting/lead/lead-status',
							active: false,
							accessName: 'lead-status-report',
							index: 2,
						},
						{
							name: 'Duplicate Lead ID',
							link: '/reporting/lead/duplicate-lead-identification-report',
							active: false,
							accessName: 'duplicate-lead-identification-report',
							index: 2,
						},
						{
							name: 'Contact List QA',
							link: '/reporting/cdr/contact-list-quality-assurance-report',
							active: false,
							accessName: 'contact-list-quality-assurance-report',
							index: 2,
						},
					],
				},
				*/
        {
          name: "OBD",
          isShow: "none",
          color: "#ffff",
          arrow: "keyboard_double_arrow_down",
          childs: [
            {
              name: "Broadcast",
              link: "/reporting/cdr/broadcast-cdr-report",
              active: false,
              accessName: "broadcast-cdr-report",
              index: 3,
            },
          ],
        },
        {
          name: "CPASS",
          isShow: "none",
          color: "#ffff",
          arrow: "keyboard_double_arrow_down",
          childs: [
            {
              name: "Outbound",
              link: "/reporting/cdr/cpaas-outbound-cdr-report",
              active: false,
              accessName: "cpass-outbound-cdr-report",
              index: 4,
            },
            {
              name: "Inbound",
              link: "/reporting/cdr/cpaas-inbound-cdr-report",
              active: false,
              accessName: "cpass-inbound-cdr-report",
              index: 4,
            },
          ],
        },
        {
          name: "Log",
          isShow: "none",
          color: "#ffff",
          arrow: "keyboard_double_arrow_down",
          childs: [
            {
              name: "Webhooks",
              link: "/reporting/webhooks-report",
              active: false,
              accessName: "webhook-report",
              index: 5,
            },
          ],
        },
      ];
    }

    list = checkAccessForList(this.props.accessDefination, list);

    return makeActive(list, pathname);
  }

  openMenu(item) {
    this.state.list.map((e) => {
      if (e.name === item.name) {
        e.isShow = e.isShow === "none" ? "block" : "none";
        e.arrow =
          e.arrow === "keyboard_double_arrow_down"
            ? "keyboard_double_arrow_up"
            : "keyboard_double_arrow_down";
      } else {
        e.isShow = "none";
        e.arrow = "keyboard_double_arrow_down";
      }
    });
    this.setState({ list: this.state.list });
  }
  render() {
    const { location, history, role, className = "" } = this.props;
    return (
      <ReportingDropdown className={`for-background ${className}`}>
        <RowTitle
          className="secondRow boxsmall-title"
          style={{ margin: "30px", borderRadius: "10px" }}
        >
          {"Reports"}
        </RowTitle>
        <div
          style={{
            height: "calc(100vh - 162px)",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {this.state.list.map((e) => {
            return (
              <div>
                <div
                  className={`select d-flex align-items-center justify-content-between`}
                  onClick={() => {
                    this.openMenu(e);
                  }}
                >
                  {e.name}
                  <span class={`material-symbols-outlined icon`}>
                    {e.arrow}
                  </span>
                </div>
                <div style={{ display: e.isShow }}>
                  {e.childs.map((ele) => {
                    return (
                      <Link to={ele.link} style={{ textDecoration: "none" }}>
                        <div
                          className={`option ${
                            ele.active === true ? "active" : ""
                          }`}
                          onClick={() => {
                            this.setState({ list: this.state.list });
                          }}
                        >
                          {ele.name}
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </ReportingDropdown>
    );
  }
}

const stateToProps = (state) => ({
  currentUser: globalStateSelector.getDynamic(state, { key: "currentUser" }),
  accessDefination: globalStateSelector.getDynamic(state, {
    key: "accessDefination",
  }),
});

const dispatchToProps = (dispatch) => ({
  dynamicUpdate: (data) => {},
});

export default connect(
  stateToProps,
  dispatchToProps
)(withRouter(ReportingDropdownMenu));



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ReportingDropdownMenu.js